import { LOCAL_STORAGE_KEYS, SERVER_TYPES } from "../constants";

export const getServerUri = () => {
    const selectedServerType = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_TYPE);

    if (window.location.hostname === 'validation.grotech.ai') {
        return process.env.REACT_APP_STAGING_API;
    }
    if (selectedServerType && selectedServerType === SERVER_TYPES.PRODUCTION) {
        return process.env.REACT_APP_API;
    }
    if (selectedServerType && selectedServerType === SERVER_TYPES.STAGING) {
        return process.env.REACT_APP_STAGING_API;
    }

    return process.env.REACT_APP_API;
}
